import React, { useRef, useState } from "react";
import PricingBlock from "../ChoosePlans/PricingBlock";
import RecessImage from "../../../Assets/Images/fun1.png";
import RecessImageTwo from "../../../Assets/Images/fun2.png";
import RecessImageThree from "../../../Assets/Images/fun3.png";
import RecessPImage from "../../../Assets/Images/gr1.png";
import RecessPImage1 from "../../../Assets/Images/group_right.png";
import schoolProgramsFun from "../../../Assets/Images/school-programs-fun.png";
import schoolProgramSkills from "../../../Assets/Images/school-programs-skills.png";
import funDay from "../../../Assets/Images/fun-day.png";
import funDayMobile from "../../../Assets/Images/funday-banner-mobile.png";
import skillsDrills from "../../../Assets/Images/skills-drills-desktop.png";
import skillsDrillsMobile from "../../../Assets/Images/skills-drills-mobile.png";
import "./skillsanddrills.css";
import { BsFillPauseCircleFill, BsFillPlayCircleFill } from "react-icons/bs";
import {
  MEDIA_LINKS,
  COMMON_THUMBNAIL_URL,
} from "../../../Constants/mediaLinks";

export default function SkillsAndDrills() {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleVideoEnd = () => {
    setIsPlaying(false);
  };
  const plans = [
    {
      color: "#DDE327",
      title: "Fun Day",
      price: "$ 65 / person",
      features: [
        "4-6 stations throughout the day",
        "Arts & crafts, video games, and more!",
        "1 hour lunch break included",
        "Optional guest speaker or entertainment",
      ],
      image: schoolProgramsFun,
      bottomImage: RecessPImage,
    },
  ];
  const plans1 = [
    {
      color: "#22E654",
      title: "Skills & Drills",
      price: "$ 450 / Hr",
      features: [
        "2 specialists per 30 players",
        "Choose from a variety of sports",
        "Bulk discounts available",
      ],
      image: schoolProgramSkills,
      bottomImage: RecessPImage,
    },
  ];
  return (
    <>
      <div className="sports-rec-day">
        <div className="recess-heading">
          <div className="new-image-border">
            <img className="fun-img-desktop" src={funDay} alt="fun-day" />
            <img
              className="fun-img-mobile"
              src={funDayMobile}
              alt="fun_day_mobile"
            />
            {/* <h2>Fun Day</h2>
                <div className="recess-images">
                    <img src={RecessImage} alt="recess" />
                    <img src={RecessImageTwo} alt="recess" />
                    <img src={RecessImageThree} alt="recess" />
                </div> */}
          </div>
        </div>
        <div className="sports-rec-day-content">
          <div className="choose-plans-list sad-price-container fun-day-plans-list">
            {plans.map((plan, index) => (
              <PricingBlock
                key={index}
                title={plan.title}
                price={plan.price}
                features={plan.features}
                image={plan.image}
                color={plan.color}
                bottomImage={plan.bottomImage}
              />
            ))}
          </div>

          <div className="video-container fun-day-video-container">
            <div
              style={{
                width: "100%",
                height: "600px",
                overflow: "hidden",
                borderRadius: "20px",
              }}
            >
              <video
                controls
                autoPlay
                muted
                poster={MEDIA_LINKS.SCHOOL_PROGRAMS.VIDEO_03}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain", // fills container, crops if needed
                }}
              >
                <source
                  src={MEDIA_LINKS.SCHOOL_PROGRAMS.VIDEO_03}
                  type="video/mp4"
                />
              </video>
            </div>
          </div>
        </div>
      </div>
      <div className="sports-rec-day">
        <div className="recess-heading">
          <div className="new-image-border">
            <img
              className="fun-img-desktop"
              src={skillsDrills}
              alt="skills-drills"
            />
            <img
              className="fun-img-mobile"
              src={skillsDrillsMobile}
              alt="skills_mobile"
            />
            {/* <h2>Skills & Drills</h2>
            <div className="recess-images">
              <img src={RecessImage} alt="recess" />
              <img src={RecessImageTwo} alt="recess" />
              <img src={RecessImageThree} alt="recess" />
            </div> */}
          </div>
        </div>
        <div className="sports-rec-day-content">
          <div className="choose-plans-list sad-price-container">
            {plans1.map((plan, index) => (
              <PricingBlock
                key={index}
                title={plan.title}
                price={plan.price}
                features={plan.features}
                image={plan.image}
                color={plan.color}
                bottomImage={plan.bottomImage}
              />
            ))}
          </div>

          {/* <div className="skills-images-container">
                    <div className="skills-image-item item1">
                        <img src="https://www.shutterstock.com/shutterstock/photos/2463190611/display_1500/stock-photo-different-sports-equipment-on-green-grass-flat-lay-2463190611.jpg" alt="img1"/>
                    </div>
                    <div className="skills-image-item item2">
                    <img src="https://www.shutterstock.com/shutterstock/photos/2463190611/display_1500/stock-photo-different-sports-equipment-on-green-grass-flat-lay-2463190611.jpg" alt="img2"/>
                    </div>
                    <div className="skills-image-item item3">
                        <img src="https://www.shutterstock.com/shutterstock/photos/2463190611/display_1500/stock-photo-different-sports-equipment-on-green-grass-flat-lay-2463190611.jpg" alt="img3"/>
                    </div>
                    <div className="skills-image-item item4">
                        <img src="https://www.shutterstock.com/shutterstock/photos/2463190611/display_1500/stock-photo-different-sports-equipment-on-green-grass-flat-lay-2463190611.jpg" alt="img4"/>
                    </div>
                    <div className="skills-image-item item5">
                        <img src="https://www.shutterstock.com/shutterstock/photos/2463190611/display_1500/stock-photo-different-sports-equipment-on-green-grass-flat-lay-2463190611.jpg" alt="img5"/>
                    </div>
                    <div className="skills-image-item item6">
                        <img src="https://www.shutterstock.com/shutterstock/photos/2463190611/display_1500/stock-photo-different-sports-equipment-on-green-grass-flat-lay-2463190611.jpg" alt="img6"/>
                    </div>
                </div> */}
          <div className="video-container">
            <img
              src={RecessPImage1}
              style={{ width: "100%" }}
              alt="Recess img"
            />
          </div>
        </div>
      </div>
    </>
  );
}
